module.exports = __webpack_public_path__ + "static/media/YesterdayLogoWjote.12116b7a.png";